// Option One (/service-entry-optionone): an (i) icon on each card opens its description.
import React, { useCallback, useEffect, useId, useRef, useState } from "react";
import { NO_DESCRIPTION, useServiceColumns } from "./serviceData";
import { ServiceEntryShell, ServiceTile } from "./shared";

function InfoPopover({ item, open, onToggle, onClose }) {
  const ref = useRef(null);
  const popoverId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onPointer = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("mousedown", onPointer);
    document.addEventListener("touchstart", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("touchstart", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  return (
    <div ref={ref}>
      <button
        type="button"
        className="se-info-btn"
        aria-label={`About ${item.label}`}
        aria-expanded={open}
        aria-controls={popoverId}
        onClick={onToggle}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 11v5M12 8v.01" />
        </svg>
      </button>
      {open && (
        <div className="se-info-popover" id={popoverId} role="dialog" aria-label={item.label}>
          <p className="se-info-title">{item.label}</p>
          <p className="se-info-text">{item.description || NO_DESCRIPTION}</p>
          <button type="button" className="se-info-close" onClick={onClose}>
            Got it
          </button>
        </div>
      )}
    </div>
  );
}

export default function ServiceEntryOptionOne() {
  const columns = useServiceColumns();
  const [openLabel, setOpenLabel] = useState(null);
  const close = useCallback(() => setOpenLabel(null), []);

  return (
    <ServiceEntryShell variant="a" hint="Click the (i) on any card to read what it is.">
      <div className="service-entry-columns">
        {columns.map((column) => (
          <section className="service-entry-column" key={column.title}>
            <h2>{column.title}</h2>
            <div className="service-entry-list">
              {column.items.map((item) => {
                const open = openLabel === item.label;
                return (
                  <div className={`se-tile-wrap${open ? " is-open" : ""}`} key={item.label}>
                    <ServiceTile item={item} />
                    <InfoPopover
                      item={item}
                      open={open}
                      onToggle={() => setOpenLabel(open ? null : item.label)}
                      onClose={close}
                    />
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </ServiceEntryShell>
  );
}
